import axios from "axios";
import { attachTokenRefresh } from "@/utils/authInterceptors";
import { notify } from '@/utils/notify';
import store from "@/store";
import i18n from "@/i18n.js"
import { v4 as uuidv4 } from 'uuid';
const { t, te } = i18n.global;

const service = axios.create({
    baseURL: process.env.VUE_APP_ENV === "production"
        ? "https://api.vibrant-america.com/v2/portal/trans-service/"
        : "https://api.vibrant-america.com/v2/portal/trans-service-st/"
});

service.interceptors.request.use(
    async function (config) {
        // Get token from sessionStorage first (EHR stores token there), then fallback
        const sessionStorageToken = sessionStorage.getItem('token') || sessionStorage.getItem('jwtToken');
        const token = sessionStorageToken ||
          localStorage.getItem('token') ||
          store?.state?.login?.token ||
          '';
    
        // Set Authorization header (same format as portal)
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
    
        // Always set lisCookie header (like Portal - even if empty)
        config.headers.lisCookie = `JSESSIONID=${localStorage.getItem('jSessionId') || ''}`;
    
        // Add x-request-id header (same as portal)
        config.headers['X-request-id'] = uuidv4();
    
        return config;
      },
    function (error) {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    response => {
        if (response?.status >= 200 && response?.status < 300) {
            return response;
        } else {
            notify({
                title: 'Failed',
                type: 'error',
                message: te(`Commons["${response.message}"]`) ? t(`Commons["${response.message}"]`) : response.message,
                duration: 0,
                zIndex: 999999,
            });
            return Promise.reject(response);
        }
    },
    error => {
        if (error?.response?.status === 401) {
            store.dispatch('login/handleAuthError');
            return Promise.reject(error);
        }
        const errorMsg = error.response?.data?.errorMessage || error.response?.data?.message || error.message;
        notify({
            title: t("SettingPage[\"Failed\"]"),
            message: te(`Commons["${errorMsg}"]`) ? t(`Commons["${errorMsg}"]`) : errorMsg,
            type: "error",
            duration: 8000,
            zIndex: 999999,
        });
        return Promise.reject(error);
    }
);

attachTokenRefresh(service);

export default service;
